import { useState, useEffect } from "react";
import { Menu, X, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { href: "#services", label: "Services" },
  { href: "#about", label: "About" },
  { href: "#testimonials", label: "Reviews" },
  { href: "#contact", label: "Contact" },
];

export default function Header({ onBookClick }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0A0A0C]/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="grid place-items-center w-9 h-9 rounded-lg bg-[#D4AF37] text-black">
            <ShieldCheck size={18} strokeWidth={2.2} />
          </span>
          <span className="font-semibold tracking-tight text-white text-lg">
            All Service <span className="text-[#D4AF37]">Proz</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-white/70 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:4708080832"
            data-testid="header-phone-link"
            className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors"
          >
            470-808-0832
          </a>
          <Button
            data-testid="header-book-button"
            onClick={onBookClick}
            className="bg-[#D4AF37] text-black hover:bg-[#C5A017] font-semibold rounded-full px-5"
          >
            Book Service
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0A0A0C]/95 backdrop-blur-xl">
          <div className="px-6 py-5 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-white/80 hover:text-white"
              >
                {l.label}
              </a>
            ))}
            <Button
              data-testid="mobile-header-book-button"
              onClick={() => {
                setOpen(false);
                onBookClick();
              }}
              className="bg-[#D4AF37] text-black hover:bg-[#C5A017] font-semibold rounded-full mt-2"
            >
              Book Service
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
